import { BreadcrumbLoader } from "../../../../decorators/BreadcrumbLoader";
import { BreadcrumbNameLoader } from "../../../../services/breadcrumbs/breadcrumbLoaders/breadcrumbNameLoaders/BreadcrumbNameLoader";
import { texts } from "../../../../i18n/texts";

@BreadcrumbLoader("/customer-table")
export class AdminViewCustomerTableBreadcrumbNameLoader extends BreadcrumbNameLoader {
  name = texts.adminView.customerTable;
}
